/**
 * Rate Limit Handler Hook
 *
 * Listens for rate limit events from the API client and shows toast notifications.
 * Uses the modern EventTarget pattern for event handling.
 */

import { useEffect } from 'react';
import { rateLimitEmitter } from '../api/adminClient';
import type { RateLimitEventDetail } from '../api/adminClient';
import { useToast } from './useToast';

export function useRateLimitHandler(): void {
  const toast = useToast();

  useEffect(() => {
    const handleRateLimit = (event: Event) => {
      const { retryAfter } = (event as CustomEvent<RateLimitEventDetail>).detail;
      toast.warning(
        `Rate limited. Please wait ${retryAfter} seconds before trying again.`,
        retryAfter * 1000 + 1000 // Show toast for duration + 1 second
      );
    };

    rateLimitEmitter.addEventListener('ratelimit', handleRateLimit);

    return () => {
      rateLimitEmitter.removeEventListener('ratelimit', handleRateLimit);
    };
  }, [toast]);
}

export default useRateLimitHandler;
